export default "__VITE_PUBLIC_ASSET__0bdd4f2b__"